/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Account_N_Technical__Question_6Inputs */

const en_help_center__account_n_technical__question_6 = /** @type {(inputs: Help_Center__Account_N_Technical__Question_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is my account secure?`)
};

/**
* | output |
* | --- |
* | "Is my account secure?" |
*
* @param {Help_Center__Account_N_Technical__Question_6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__account_n_technical__question_6 = /** @type {((inputs?: Help_Center__Account_N_Technical__Question_6Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Account_N_Technical__Question_6Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__account_n_technical__question_6(inputs)
});